import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { Field } from 'formik';
import theme from '../../../../styles/theme';
import Label from '../Label';
import StyledErrorMessage from '../StyledErrorMessage';

const Input = ({
  label, classes, id, errors, touched, required, type, ...rest
}) => (
  <div className={cn(classes.wrapper, {
    [classes.error]: touched[id] && errors[id],
    [classes.valid]: touched[id] && !errors[id],
  })}
  >
    <Label
      className={classes.label}
      htmlFor={id}
      text={label}
      required={required}
    />
    <Field
      {...rest}
      type={type}
      id={id}
      name={id}
      className={cn(classes.input)}
    />

    {type === 'email' && (
      <div
        className={classes.check}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: '<svg width="12" height="9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M10.646.646a.5.5 0 0 1 .708.708L4.4 8.306a.5.5 0 0 1-.707 0L.646 5.258a.5.5 0 0 1 .708-.707l2.694 2.694L10.646.646z" id="a"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><use fill="#42ABC8" fill-rule="nonzero" xlink:href="#a"/><g mask="url(#b)" fill="#42ABC8"><path d="M-2-4h16v16H-2z"/></g></g></svg>',
        }}
      />
    )}
    <StyledErrorMessage name={id} />
  </div>
);

Input.defaultProps = {
  type: 'text',
  required: true,
};

Input.propTypes = {
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  touched: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.bool])).isRequired,
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  required: PropTypes.bool,
};

export default compose(
  injectSheet({
    wrapper: {
      position: 'relative',
      padding: '0 8px 16px 8px',
      flexGrow: 1,
      '& > textarea': {
        fontSize: '13px',
        borderRadius: '2px',
      },
    },
    label: {
      color: 'inherit',
    },
    input: {
      minWidth: '50%',
    },
    error: {
      '& > input, & > textarea, & > select': {
        borderColor: theme.colors.brandError,
      },
    },
    valid: {
      '& > input[type="email"] ~ $check': {
        visibility: 'visible',
      },
    },
    check: {
      display: 'flex',
      visibility: 'hidden',
      position: 'absolute',
      right: '20px',
      top: '45px',
    },
  }),
)(Input);
